import { create } from 'zustand';

interface AppState {
  isFocusMode: boolean;
  isRainActive: boolean;
  hasEntered: boolean;
  toggleFocusMode: () => void;
  toggleRain: () => void;
  setEntered: (value: boolean) => void;
}

export const useStore = create<AppState>((set) => ({
  isFocusMode: false,
  isRainActive: false,
  hasEntered: false,
  toggleFocusMode: () => set((state) => ({ isFocusMode: !state.isFocusMode })),
  toggleRain: () => set((state) => ({ isRainActive: !state.isRainActive })),
  setEntered: (value: boolean) => set({ hasEntered: value }),
}));
